import twitter from './../assets/projet.png';
import mycine from './../assets/mycine.png';
import snap from './../assets/snap.jpg';
import france from './../assets/france.png';
import us from './../assets/us.png';
import meetic from './../assets/meetic.jpg';
import irc from './../assets/irc.jpg';

const en = {
  navbar: {
    home: "Home",
    experience: "Experience",
    projects: "Projects",
    contact: "Contact",
    changeLanguage: "Change Language"
  },
  hero: {
    hello: "Hello, my name is",
    name: "Tony Brechard.",
    description: "I am a young full stack developer passionate about creating complete web solutions. With skills in both front-end and back-end development.",
    seeProjects: "See my projects"
  },
  education: {
    title: "Experience",
    date: "2024-2026",
    school: "Web@cadémie by Epitech",
    description: "The Web@cadémie by Epitech is an intensive 24-month training program that prepares young people, with or without a diploma, for careers in web development. The training combines project-based learning, intensive coding immersion, and work-study opportunities, allowing students to earn a recognized title while gaining solid professional experience.",
    tags: ["JavaScript", "PHP", "HTML/CSS", "MySQL", "React", "Express", "Symfony", "SocketIo", "Laravel"]
  },
  projects: {
    title: "Projects",
    webButton: "Web",
    mobileButton: "Mobile",
    web: [
      {
        title: "My IRC",
        description: "A web project simulating a cinema website, with features such as movie listings, ticket reservations, and user authentication.",
        tags: ["Node.Js", "Express.js", "CSS", "Socket.io", "React.js"],
        image: irc,
        link: 'https://github.com/onlyguts/my_irc'
      },
      {
        title: "My Meetic",
        description: "A web project simulating a dating website, with features such as user registration, profile search, and messaging.",
        tags: ["PHP", "HTML/CSS", "MySQL"],
        image: meetic,
        link: 'https://github.com/onlyguts/my_meetic'
      },
      {
        title: "My Cinema",
        description: "A web project simulating a cinema website, with features such as movie listings, ticket reservations, and user authentication.",
        tags: ["PHP", "HTML/CSS", "MySQL"],
        image: mycine,
        link: 'https://github.com/onlyguts/my_cinema'
      },
      {
        title: "My Twitter",
        description: "A web clone of Twitter allowing users to post tweets, follow other users, and interact through likes and comments.",
        tags: ["PHP", "JavaScript", "HTML/CSS", "MySQL", 'Ajax'],
        image: twitter,
        link: 'https://github.com/onlyguts/my_twitter'
      }
    ],
    mobile: [
      {
        title: "My Snapchat",
        description: "A mobile app replicating the core features of Snapchat, including sending snaps, viewing stories, and messaging.",
        tags: ["TypeScript", "React Native", "Expo", 'CSS'],
        image: snap,
        link: 'https://github.com/onlyguts/my_snapchat'
      }
    ]
  },
  contact: {
    title: "Contact",
    form: {
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send"
    }
  },
  footer: "© Tony BRECHARD 2024. - All rights reserved."
};

export default en;
